<p-dialog
  modal="true"
  styleClass="atlas-dialog-m"
  position="top"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h4>
      {{ (newsArticle.ArticleId ? 'news-articles.edit.edit-an-article' : 'news-articles.create.add-an-article') | translate | titlecase }}
    </h4>
  </ng-template>
  <form #editForm="ngForm">
    <div class="atlas-form mct-flex mct-col mct-gap-27"   [wl-busy-overlay]="loading" [busyCenter]="true">
      <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-between mct-items-center mct-gap-27"    >
        <div class="mct-basis-70" >
          <label>{{ 'news-articles.edit.short-descr' | translate | titlecase }}</label>
          <input name="ShortDescr" [(ngModel)]="newsArticle.ShortDescr" required />
        </div>
        <div class="mct-flex mct-col mct-justify-start mct-items-stretch"  >
          <label>{{ 'news-articles.edit.article-type' | translate | titlecase }}</label>
          <p-select
            name="articleType"
            appendTo="body"
            [placeholder]="'common.select-dashes' | translate | titlecase"
            [options]="articleTypeItems"
            [(ngModel)]="newsArticle.ArticleType"
            required
          ></p-select>
        </div>
      </div>
      <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-between mct-items-center mct-gap-27"    >
        <div class="mct-flex mct-col" >
          <label>{{ 'news-articles.edit.article-date' | translate | titlecase }}</label>
          <wl-date-selector appendTo="body" name="ArticleDate" [(ngModel)]="newsArticle.ArticleDate" [required]="true"></wl-date-selector>
        </div>
        <div class="mct-flex mct-row mct-flex-lt-md mct-col-lt-md mct-justify-between mct-items-center mct-gap-27 mct-basis-50"     >
          <div class="mct-flex mct-col" >
            <label>{{ 'news-articles.edit.start-date' | translate | titlecase }}</label>
            <wl-date-selector appendTo="body" name="StartDate" [(ngModel)]="newsArticle.StartDate" [required]="true"></wl-date-selector>
          </div>
          <div class="mct-flex mct-col" >
            <label>{{ 'news-articles.edit.end-date' | translate | titlecase }}</label>
            <wl-date-selector appendTo="body" name="EndDate" [(ngModel)]="newsArticle.EndDate" [required]="true"></wl-date-selector>
          </div>
        </div>
      </div>
      <div *ngIf="showEditor">
        <wl-wysiwyg-editor name="LongDescr" [showHtmlTemplates]="false" [disableImageSelector]="true" [(ngModel)]="newsArticle.LongDescr" [compact]="true">
        </wl-wysiwyg-editor>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="mct-flex mct-row mct-flex-lt-sm mct-col-lt-sm mct-justify-end mct-items-center mct-gap-10"    >
      <button pButton type="button" class="atlas-btn atlas-btn-secondary" [disabled]="isSaving" (click)="close()">
        {{ 'common.cancel' | translate | uppercase }}
      </button>
      <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!editForm.valid" (click)="save()">
        <wl-busy [show]="isSaving"></wl-busy>
        <span [hidden]="isSaving">{{ 'common.save' | translate | uppercase }}</span>
      </button>
    </div>
  </ng-template>
</p-dialog>
